import { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Loader2 } from "lucide-react"
import type { AppShell } from "@/App"
import { producaoApi, errorMessage } from "./api"

/**
 * `/contracts/<contract_id>` — o «Abrir na app» da ficha do contrato no
 * Koortex. A obra é o contrato: procura a obra com esse `contract_id` e abre o
 * Detalhe (G4). Sem obra (contrato criado fora da app) diz-o em vez de abrir
 * o menu.
 */
export function ContractLink({ shell }: { shell: AppShell | null }) {
  const { contractId } = useParams<{ contractId: string }>()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!shell || !contractId) return
    let cancelled = false
    producaoApi
      .jobByContract(shell, contractId)
      .then((r) => !cancelled && navigate(`/producao/obras/${r.job_id}`, { replace: true }))
      .catch((err) => !cancelled && setError(errorMessage(err)))
    return () => {
      cancelled = true
    }
  }, [shell, contractId, navigate])

  if (error) {
    return (
      <div className="mx-auto max-w-md p-8 text-center">
        <h1 className="text-lg font-semibold">Obra não encontrada</h1>
        <p className="mt-2 text-sm text-muted-foreground">{error}</p>
        <Link to="/producao" className="mt-4 inline-block text-sm text-accent hover:underline">
          Ir para o quadro da Produção
        </Link>
      </div>
    )
  }
  return (
    <div className="flex justify-center py-24 text-muted-foreground">
      <Loader2 className="h-6 w-6 animate-spin" />
    </div>
  )
}
